import { render, staticRenderFns } from "./communityArticleTag.vue?vue&type=template&id=67a1a846"
import script from "./communityArticleTag.vue?vue&type=script&lang=js"
export * from "./communityArticleTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports